import { PrimaryButton } from "components/Button/style";
import { CustomInputModal } from "components/CustomInputModal";
import { CustomDatePicker } from "components/DatePicker";
import { DropdownSelect } from "components/DropdownSelect";
import { useCallback, useMemo } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm, useWatch } from "react-hook-form";
import { TIPO_SOLICITACAO_PLACA } from "../../../SolicitacaoPlaca/constants/tipoSolicitacaoPlaca";
import {
  BotoesContainer,
  Container,
  Title,
} from "../../../SolicitacaoPlaca/containers/Filtros/style";
import { useUsuariosSolicitacaoPlaca } from "../../../SolicitacaoPlaca/hooks/useUsuariosSolicitacaoPlaca";
import { codigoOuNulo } from "../../../SolicitacaoPlaca/utils/codigoOuNulo";
import { FILTROS_LOTES_TERCEIROS_VAZIOS } from "../../constants/filtrosLotesTerceiros";
import { useFornecedoresTerceiros } from "../../hooks/useFornecedoresTerceiros";
import { IFiltrosLotesTerceiros } from "../../interfaces/IFiltrosLotesTerceiros";

interface IProps {
  onBuscar: (filtros: IFiltrosLotesTerceiros) => void;
}

export function FiltrosLotes({ onBuscar }: IProps) {
  const { control, handleSubmit, reset, setValue } =
    useForm<IFiltrosLotesTerceiros>({
      defaultValues: FILTROS_LOTES_TERCEIROS_VAZIOS,
    });
  const idFornecedor = useWatch({ control, name: "idFornecedor" });
  const idUsuario = useWatch({ control, name: "idUsuario" });
  const periodo = useWatch({ control, name: "periodoEnvio" });
  const [dataInicio, dataFim] = periodo ?? [];
  const { usuariosOptions } = useUsuariosSolicitacaoPlaca(
    TIPO_SOLICITACAO_PLACA.TERCEIROS
  );
  const { fornecedores, carregando: carregandoFornecedores } =
    useFornecedoresTerceiros();
  const fornecedoresOptions = useMemo(
    () => fornecedores.map(({ id, nome }) => ({ value: id, label: nome })),
    [fornecedores]
  );

  // DropdownSelect chama onSelect(null) num efeito que depende dele: onSelect precisa ser estável.
  const selecionarUsuario = useCallback(
    (valor: string | number | null) => {
      setValue("idUsuario", codigoOuNulo(valor));
    },
    [setValue]
  );

  const selecionarFornecedor = useCallback(
    (valor: string | number | null) => {
      setValue("idFornecedor", codigoOuNulo(valor));
    },
    [setValue]
  );

  function handleLimpar() {
    reset(FILTROS_LOTES_TERCEIROS_VAZIOS);
    onBuscar(FILTROS_LOTES_TERCEIROS_VAZIOS);
  }

  return (
    <Container>
      <Title>Filtros</Title>
      <hr />
      <Form noValidate onSubmit={handleSubmit((filtros) => onBuscar(filtros))}>
        <Row>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Lote</Form.Label>
              <Controller
                control={control}
                name="idLote"
                render={({ field: { value, onChange } }) => (
                  <CustomInputModal
                    label="Filtrar em massa"
                    value={value}
                    placeholder="Busque pelo lote"
                    onConfirm={onChange}
                    validar={false}
                    style={{ width: "100%" }}
                    placeholderModal="Digite ou cole os lotes e tecle ENTER"
                    labelItem="Lote"
                  />
                )}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Fornecedor</Form.Label>
              <DropdownSelect
                options={fornecedoresOptions}
                selectedValue={idFornecedor}
                onSelect={selecionarFornecedor}
                loading={carregandoFornecedores}
                searchable
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Usuário responsável</Form.Label>
              <DropdownSelect
                options={usuariosOptions}
                selectedValue={idUsuario}
                onSelect={selecionarUsuario}
                searchable
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Período de envio</Form.Label>
              <Controller
                control={control}
                name="periodoEnvio"
                render={({ field: { onChange } }) => (
                  <CustomDatePicker
                    placeholder="Selecione o período"
                    rangeSelect
                    startDate={dataInicio ?? undefined}
                    endDate={dataFim ?? undefined}
                    onChange={(datas) => onChange(datas)}
                  />
                )}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <BotoesContainer>
              <PrimaryButton
                type="button"
                outline
                variante="primary"
                onClick={handleLimpar}
              >
                Limpar
              </PrimaryButton>
              <PrimaryButton type="submit">Buscar</PrimaryButton>
            </BotoesContainer>
          </Col>
        </Row>
      </Form>
    </Container>
  );
}
